export const DETAILS_VIEW_SIMPLE = 'simple';
export const DETAILS_VIEW_PREORDER = 'preorder';
export const DETAILS_VIEW_OUT_OF_STOCK = 'outofstock';
export const DETAILS_VIEW_TARIFF = 'tariff';

export const DetailsViewTypes = [
  DETAILS_VIEW_SIMPLE,
  DETAILS_VIEW_PREORDER,
  DETAILS_VIEW_OUT_OF_STOCK,
  DETAILS_VIEW_TARIFF,
];

export const CONTENT_TAB_ABOUT = 'about';
export const CONTENT_TAB_DELIVERY = 'delivery';
export const CONTENT_TAB_FEEDBACK = 'otzyvy';
export const CONTENT_TAB_SERVICES = 'services';
export const CONTENT_TAB_PAYMENT = 'payment';
export const CONTENT_TAB_PROMO = 'promo';
export const CONTENT_TAB_PREORDER = 'preorder';
export const CONTENT_TAB_CROSS_SALE = 'aksessuary';
export const CONTENT_TAB_LEASING = 'content-samsung_upgrade';

export const TabEnum = {
  CONTENT_TAB_ABOUT,
  CONTENT_TAB_DELIVERY,
  CONTENT_TAB_FEEDBACK,
  CONTENT_TAB_SERVICES,
  CONTENT_TAB_PAYMENT,
  CONTENT_TAB_PROMO,
  CONTENT_TAB_PREORDER,
  CONTENT_TAB_CROSS_SALE,
  CONTENT_TAB_LEASING,
};

export const SERVICE_TYPE_INSURANCE = 'insurance';

export const TAKEAWAY_VIEW_LIST = 'list';
export const TAKEAWAY_VIEW_MAP = 'map';

export const TARIFF_BRAND_NAME = 'Tariffs';

export const DELIVERY_TAKEAWAY_OFFICE = 'op';
export const DELIVERY_TAKEAWAY_PICKUP = 'pick_up_point';
export const DELIVERY_TAKEAWAY_POSTAMATE = 'parcel_automat';

export const DETAILS_PART_OF_PATH = 'details';
